<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Heading from "../../layouts/heading.vue";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import api from "../../../api";
import JsonForm from "../../layouts/form";
import Switches from "vue-switches";

export default {
  page: {
    title: "Users",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Heading, JsonForm, Switches },
  data() {
    return {
      selectPracticeFlag: false,
      selectedUsers: [],
      enabled: true,
      editFormData: null,
      users: null,
      practices: null,
      page: {
        title: "Users",
        lastUpdated: false,
        addNewBtn: true,
        addNewModalTitle: "Create New Page",
        table: {
          rows: {},
          tableCols: [
            { key: "name", type: "", sortable: false },
            { key: "CREATE", type: "checkbox", sortable: false },
            { key: "READ", type: "checkbox", sortable: false },
            { key: "UPDATE", type: "checkbox", sortable: false },
            { key: "UPDATEMANY", type: "checkbox", sortable: false },
            { key: "DELETE", type: "checkbox", sortable: false },
            { key: "LIST", type: "checkbox", sortable: false },
            { key: "COUNT", type: "checkbox", sortable: false },
            { key: "EXECUTE", type: "checkbox", sortable: false },
            { key: "AccessAuthFeature", type: "checkbox", sortable: false },
          ],
        },
        formData: {
          isAdmin: {
            Admin: false,
          },
          permissions: {},
        },
        schema: {
          name: {
            type: "text",
            label: "Name",
            placeholder: "Enter Name",
            required: true,
            info: false,
            character_count: 50,
          },
          email: {
            type: "text",
            label: "Email",
            placeholder: "Enter Email",
            required: true,
            info: false,
            character_count: 50,
          },
          // password: {
          //     type: 'password',
          //     label: 'Password',
          //     placeholder: 'Enter Password',
          //     required: true,
          //     info: false,
          //     character_count: 0
          // },
          // isAdmin: {
          //     type: 'checkbox',
          //     label: 'Only for Admin Access',
          //     options: ['Admin'],
          //     placeholder: '',
          //     required: false,
          //     info: false,
          //     character_count: 0
          // },
          role: {
            type: "select",
            label: "Role",
            options: [],
            placeholder: "",
            required: false,
            info: false,
            character_count: 0,
          },
          // permissions: {
          //     type: 'button',
          //     label: 'Permissions',
          //     // placeholder: 'Enter Password',
          //     // required: false,
          //     // info: false,
          //     // character_count: 0
          // },
        },
        editSchema: {
          name: {
            type: "text",
            label: "Name",
            placeholder: "Enter Name",
            required: true,
            info: false,
            character_count: 50,
          },
          // email: {
          //     type: 'text',
          //     label: 'Email',
          //     placeholder: 'Enter Email',
          //     required: true,
          //     info: false,
          //     character_count: 50,
          //     disabled: true
          // },
          role: {
            type: "select",
            label: "Role",
            options: [],
            placeholder: "",
            required: false,
            info: false,
            character_count: 0,
          },
          // password: {
          //     type: 'password',
          //     label: 'Password',
          //     placeholder: 'Enter Password',
          //     required: true,
          //     info: false,
          //     character_count: 0
          // },
          // isAdmin: {
          //     type: 'checkbox',
          //     label: 'Only for Admin Access',
          //     // options: ['Admin'],
          //     placeholder: '',
          //     required: false,
          //     info: false,
          //     character_count: 0
          // },
          // permissions: {
          //     type: 'button',
          //     label: 'Permissions',
          //     // placeholder: 'Enter Password',
          //     // required: false,
          //     // info: false,
          //     // character_count: 0
          // },
        },
        disBtn: false,
        deleteBtn: true,
        activeBtn: false,
        submitBtn: false,
        searchBox: true,
      },
      practice: {
        formData: {},
        schema: {
          code: {
            type: "number",
            label: "Code",
            placeholder: "Enter Code",
            required: true,
            info: false,
            character_count: 0,
          },
          type: {
            type: "text",
            label: "Type",
            placeholder: "Enter Type",
            required: true,
            info: false,
            character_count: 0,
          },
          name: {
            type: "text",
            label: "Name",
            placeholder: "Enter Name",
            required: true,
            info: false,
            character_count: 50,
          },
          url: {
            type: "text",
            label: "URL",
            placeholder: "Enter URL",
            required: true,
            info: false,
            character_count: 0,
          },
          phone: {
            type: "number",
            label: "Phone",
            placeholder: "Enter Phone Number",
            required: true,
            info: false,
            character_count: 0,
          },
          address: {
            type: "text",
            label: "Address",
            placeholder: "Enter Address",
            required: false,
            info: false,
            character_count: 0,
          },
          dynamo: {
            type: "text",
            label: "Dynamo",
            placeholder: "Enter Dynamo",
            required: false,
            info: false,
            character_count: 0,
          },
        },
      },
      items: [
        {
          text: "Tables",
          href: "/",
        },
        {
          text: "Advanced",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "check", label: "#", tdClass: "w-0", checkbox: true },
        { key: "name", sortable: false },
        { key: "email", sortable: false },
        { key: "role", sortable: false },
        { key: "active", sortable: false },
        // { key: "isAdmin", sortable: true },
        { key: "practices" },
        { key: "actions", label: "" },
      ],
      userPractices: [],
      selectedPractices: [],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    // currentUser() {
    //   return JSON.parse(localStorage.getItem('currentUser'));
    // },
    rows() {
      if (this.users) {
        return this.users.length;
      } else {
        return 0;
      }
    },
  },
  methods: {
    updateFilter(value) {
      this.filter = value;
    },
    editFormDataFn(id) {
      this.editFormData = this.users.filter((element) => element.id == id)[0];
      this.getUserPractices(id);
    },
    create(val) {
      if (val) {
        var userPer = this.page.schema.role.options.find(
          (element) => element.id == val.role
        ).permissions;
        var data = {
          uuid: uuidv4(),
          name: val.name,
          email: val.email,
          password: "N/A",
          forgotRequested: false,
          loginRequested: false,
          loginCode: {},
          active: true,
          isAdmin: true,
          permissions: userPer,
          role: val.role,
          additionalProp1: {},
        };
        api.post("/api/users", data).then(
          (response1) => {
            for (let practice of val.practicesList) {
              api
                .post(`/users/${response1.data.id}/practices/${practice}`, data)
                .then(
                  (response) => {
                    console.log(response);
                    // Swal.fire("User Created!", "User Created Successfully!", "success");
                    // this.getUsers();
                    // console.log(response)
                    // this.users.push(response.data)
                    // this.getPractices();
                  },
                  (error) => {
                    console.log(error);
                  }
                );
            }

            // console.log(response);
            Swal.fire("User Created!", "User Created Successfully!", "success");
            // this.getUsers();
            // console.log(response)
            var user_practices = this.practices.filter((x) =>
              val.practicesList.includes(x.id)
            );
            response1.data.practices = user_practices;
            this.users.push(response1.data);
            // this.getUserPractices(response1.data.id)
            // this.getPractices();
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    update(val) {
      var userPer = this.page.schema.role.options.find(
        (element) => element.id == val.role
      ).permissions;

      var data = {
        name: val.name,
        role: val.role,
        permissions: userPer,
      };

      for (let practice of this.practices) {
        api.patch(`/users/${val.id}/practices/${practice.id}`, data).then(
          () => {},
          (error) => {
            console.log(error);
          }
        );
      }

      api.patch("/api/users/" + val.id, data).then(
        () => {
          for (let practice of this.selectedPractices) {
            api.post(`/users/${val.id}/practices/${practice}`, data).then(
              () => {},
              (error) => {
                console.log(error);
              }
            );
          }

          this.getUsers();
          Swal.fire("User Updated!", "User Updated Successfully!", "success");
          this.selectPracticeFlag = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    createPracticeFn(userId) {
      this.createPractice(userId, this.practice.formData);
      this.getUsers();
      this.getPractices();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getRoles() {
      api
        .get("/api/roles")
        .then((response) => {
          this.page.schema.role.options = response.data;
          this.page.editSchema.role.options = response.data;

          // this.page.table.rows = response.data
          // this.page.formData.permissions = response.data
          // delete this.page.table.rows.timestamp
          // delete this.page.formData.permissions.timestamp
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async getUsers() {
      let filter = {
        include: [
          {
            relation: "practices",
          },
        ],
      };
      filter = encodeURIComponent(JSON.stringify(filter));
      const { data } = await api.get(`/api/users?filter=${filter}`);
      this.users = data.filter((x) => x.email !== "cms@patientlink.digital");
    },
    getPractices() {
      api
        .get("/api/practices")
        .then((response) => {
          this.practices = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDefaultPermissions() {
      api
        .get("/api/components")
        .then((response) => {
          // console.log(response.data)
          this.page.table.rows = response.data;
          this.page.formData.permissions = response.data;
          delete this.page.table.rows.timestamp;
          delete this.page.formData.permissions.timestamp;
          // console.log(this.page.table.rows)
        })
        .catch((e) => {
          console.log(e);
        });
    },
    selected(val) {
      // console.log(val.item)
      if (this.selectedUsers.find((element) => element.id == val.item.id)) {
        this.selectedUsers.pop(val.item);
      } else {
        this.selectedUsers.push(val.item);
      }
      console.log("selectedUsers", this.selectedUsers);
    },
    rowClass() {
      return "table-light";
    },
    updateUserActiveState(val) {
      // console.log(val)
      api
        .patch("/api/users/" + val.item.id, {
          active: this.users.find((element) => element.id == val.item.id)
            .active,
        })
        .then(
          () => {
            // this.getUsers()
            // Swal.fire("User Updated!", "User Updated Successfully!", "success");
          },
          (error) => {
            console.log(error);
          }
        );
    },
    selectAllPractices() {
      for (let practice of this.practices) {
        this.selectedPractices.push(practice.id);
      }
    },
    getUserPractices(val) {
      var self = this;
      api
        .get(`/users/${val}/practices`)
        .then((response) => {
          self.userPractices = response.data;
          self.selectedPractices = [];
          for (let practice of response.data) {
            self.selectedPractices.push(practice.id);
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    selectPractice(val) {
      if (this.selectedPractices.includes(val.id)) {
        this.selectedPractices = this.selectedPractices.filter((n) => {
          return n != val.id;
        });
      } else {
        this.selectedPractices.push(val.id);
      }
    },
    deleted() {
      var self = this;
      Swal.fire({
        title: `Are you sure you want to delete?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          for (const selectedUser of self.selectedUsers) {
            api.delete("/api/users/" + selectedUser.id).then(
              () => {
                Swal.fire(
                  "User Deleted!",
                  "User Deleted Successfully!",
                  "warning"
                );
                this.getUsers();
                // this.page.tabs[0].side_panel.select_a_page.options
                // .splice(
                //   this.page.tabs[0].side_panel.select_a_page.options.findIndex(function(i){
                //   return i.id === self.selectedItem.id;
                // }), 1);
              },
              (error) => {
                console.log(error);
              }
            );
          }
        }
      });
    },
    onHidden() {
      this.selectPracticeFlag = false;
    },
  },
  // watch: {
  //   page: {
  //     deep: true,
  //     handler() {
  //       if(this.page.formData.role)
  //       {
  //         this.page.table.rows = this.page.schema.role.options.filter(e => e.id == this.page.formData.role)
  //         this.page.formData.permissions = this.page.schema.role.options.filter(e => e.id == this.page.formData.role)
  //       }
  //       // delete this.page.table.rows.timestamp
  //       // delete this.page.formData.permissions.timestamp
  //     }
  //   },
  // },
  mounted() {
    this.totalRows = this.items.length;
    this.getUsers();
    this.getPractices();
    // this.getDefaultPermissions();
    this.getRoles();
  },
};
</script>

<template>
  <Layout>
    <Heading
      :page="page"
      @created="create"
      @filter="updateFilter"
      @deleted="deleted"
    ></Heading>

    <div class="row">
      <div class="col-12">
        <div class="mt-3">
          <div class="d-flex"></div>
          <!-- Table -->
          <div id="user-table" class="table-responsive mb-0">
            <b-table
              :items="users"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              tbody-tr-class="table-light font-size-16 border-bottom-light"
            >
              <template
                v-slot:cell(check)="row"
                tbody-tr-td-class="font-size-12"
              >
                <div class="badge font-size-16">
                  <!-- <i :class="row.value ? 'ri-checkbox-circle-fill text-primary' : 'ri-close-circle-fill text-danger'"></i> -->
                  <input type="checkbox" v-on:click="selected(row)" />
                </div>
              </template>
              <template v-slot:cell(role)="row">
                <div class="font-size-16">
                  {{
                    page.schema.role.options.find(
                      (element) => element.id == row.value
                    )
                      ? page.schema.role.options.find(
                          (element) => element.id == row.value
                        ).title
                      : ""
                  }}
                </div>
              </template>
              <!-- <template v-slot:cell(isAdmin)="row">
              <div class="badge font-size-16">
                <i :class="row.value ? 'ri-checkbox-circle-fill text-primary' : 'ri-close-circle-fill text-danger'"></i>
              </div>
            </template> -->
              <template v-slot:cell(active)="row">
                <div class="font-size-16">
                  <switches
                    v-on:input="updateUserActiveState(row)"
                    v-model="
                      users.find((element) => element.id == row.item.id).active
                    "
                    type-bold="false"
                    color="info"
                    class="mt-2"
                  ></switches>
                  <!-- <i :class="row.value ? 'ri-checkbox-circle-fill text-primary' : 'ri-close-circle-fill text-danger'"></i> -->
                </div>
              </template>
              <template v-slot:cell(practices)="row">
                <div v-for="practice in row.item.practices" :key="practice.id">
                  <div>
                    {{ practice.name }}
                  </div>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <button
                  v-b-modal="'editmodal' + row.item.id"
                  v-on:click="editFormDataFn(row.item.id)"
                  class="btn btn-light btn-sm float-right font-size-14"
                >
                  Edit
                </button>
                <!-- <button v-if="!row.item.isAdmin" v-b-modal="'modal' + row.item.id" class="btn btn-light btn-rounded">
                Add Practice
                <i class="mdi mdi-plus-circle ml-2"></i>
              </button> -->
                <b-modal
                  :id="'editmodal' + row.item.id"
                  centered
                  title="Edit User"
                  title-class="font-18"
                  hide-footer
                  @hidden="onHidden"
                >
                  <JsonForm
                    v-if="!selectPracticeFlag"
                    :schema="page.editSchema"
                    :formData="editFormData"
                    :page="page"
                  ></JsonForm>

                  <!-- <JsonForm v-if="!selectPracticeFlag" :page="page" :schema="page.schema" :formData="page.formData"></JsonForm> -->
                  <div v-else class="overflow-auto mb-4">
                    <a
                      class="font-weight-bold pe-auto"
                      v-on:click="selectAllPractices()"
                      >Select All</a
                    >
                    <div style="height: 300px">
                      <ul
                        v-for="item of practices"
                        v-bind:key="item.id"
                        class="list-group list-group-flush"
                      >
                        <li
                          class="list-group-item border-top pl-0"
                          :class="
                            selectedPractices.includes(item.id)
                              ? 'text-primary'
                              : ''
                          "
                          v-on:click="selectPractice(item)"
                        >
                          <img
                            v-if="selectedPractices.includes(item.id)"
                            class="align-self-center mr-3"
                            src="@/assets/images/active-tick.svg"
                            alt=""
                          />
                          <img
                            v-else
                            class="align-self-center mr-3"
                            src="@/assets/images/check-box.svg"
                            alt=""
                          />
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <b-button
                    variant="light"
                    v-on:click="selectPracticeFlag = !selectPracticeFlag"
                  >
                    <span v-if="!selectPracticeFlag">Edit Practice</span>
                    <span v-if="selectPracticeFlag">Go back</span>
                  </b-button>
                  <b-button
                    v-on:click="
                      update(editFormData);
                      $bvModal.hide('editmodal' + row.item.id);
                    "
                    class="float-right"
                    variant="primary"
                    >Update</b-button
                  >
                </b-modal>
                <b-modal
                  :id="'modal' + row.item.id"
                  centered
                  title="Add Practice"
                  title-class="font-18"
                  hide-footer
                  @hidden="onHidden"
                >
                  <JsonForm
                    :schema="practice.schema"
                    :formData="practice.formData"
                  ></JsonForm>
                  <b-button
                    v-on:click="createPracticeFn(row.item.id)"
                    class="float-right"
                    variant="primary"
                    >Create</b-button
                  >
                </b-modal>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.table td {
  border-top: 1px solid #dadce3 !important;
}
.table th {
  border-top: 1px solid #dadce3 !important;
}
.table-light {
  /* background-color: white; */
  padding: 50px;
}
</style>
